import { render, staticRenderFns } from "./PlanAbonnement.vue?vue&type=template&id=61e7e456&scoped=true&"
import script from "./PlanAbonnement.vue?vue&type=script&lang=js&"
export * from "./PlanAbonnement.vue?vue&type=script&lang=js&"
import style0 from "./PlanAbonnement.vue?vue&type=style&index=0&id=61e7e456&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e7e456",
  null
  
)

export default component.exports